/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import {Link, withRouter} from 'react-router-dom'

import Select from 'react-select'
import http from '../Interceptor/Interseptor'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import ORDER_STATUS from '../BaseComponent/ORDERSTATUS'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import AutoComplete from '../BaseComponent/autocomplete'

class EditProviderPlan extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      providers: [],
      selectedOption: {},
      productsWithPlan: '',
      productsWithoutPlan: '',
      selectedOperator: {},
      providerId: '',
      init: true
    }
  }
  componentDidMount() {
    Promise.all([this.getProviderPlan(), this.getOperators()]).then((res) => {
      // let providers = res[1]
      let operators = res[1]
      // let providerId = res[0].providerId
      let operatorId = res[0].operatorId
      // let findProvider = providers.find(item => item.providerId === providerId)
      // if (findProvider) {
      //     this.setState({
      //         selectedOption: findProvider
      //     })
      // }
      let findOperator = operators.find((item) => item.personId === operatorId)
      if (findOperator) {
        this.setState({
          selectedOperator: findOperator
        })
      }
      this.setState({
        providerId: res[0].providerId,
        init: false
      })
    })
  }

  getOperators = () => {
    return http.get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {}).then((response) => {
      if (response.data.error === null) {
        var operators = response.data.object
        for (let i = 0; i < operators.length; i++) {
          operators[i]['value'] = operators[i].personId
          operators[i]['label'] = operators[i].personId + ' - ' + operators[i].name
        }
        this.setState({
          operators: response.data.object
        })
        return response.data.object
      }
    })
  }

  getProviderPlan = () => {
    let {id} = this.props.match.params
    return http.get(`${ORDER_STATUS.ORDER_STATUS_SUPPLIER_PRODUCTS_PLANS}/${id}`, {}).then((res) => {
      if (res.data.error === null) {
        // let providerId = res.data.object.providerId;
        // let findValue = providers.find(item => item.providerId === providerId)
        this.setState({
          productsWithoutPlan: res.data.object.productsWithoutPlan,
          productsWithPlan: res.data.object.productsWithPlan
        })
        return res.data.object
      }
    })
  }

  submit(e) {
    e.preventDefault()
  }

  edit() {
    let {id} = this.props.match.params

    let providerId = this.state.providerId
    let operatorId =
      this.state.selectedOperator == null || this.state.selectedOperator == ''
        ? ''
        : this.state.selectedOperator.personId

    let productsWithPlan = document.getElementById('productsWithPlan').value.trim()
    let productsWithoutPlan = document.getElementById('productsWithoutPlan').value.trim()
    if (providerId === '' || productsWithoutPlan === '' || productsWithPlan === '') {
      message.error('لطفا موارد ستاره دار تکمیل شود')
    } else {
      let data = {
        productsWithPlan,
        productsWithoutPlan,
        providerId,
        operatorId
      }
      http.put(`${ORDER_STATUS.ORDER_STATUS_SUPPLIER_PRODUCTS_PLANS}/${id}`, data, {}).then((res) => {
        if (res.data.error === null) {
          message.success('با موفقیت ویرایش شد.لطفا صبر کنید')
          setTimeout(() => {
            window.location.assign('/base/orderStatus/provider/plans')
          }, 3000)
        } else {
          message.error(res.data.description)
        }
      })
    }
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})
    // alert(JSON.stringify(selectedOption))
    console.log(`Option selected:`, selectedOption)
  }

  render() {
    let {selectedOption} = this.state

    return (
      <div className="rtl">
        {!this.state.init && (
          <div className="wrapperIframe">
            <ul className="breadcrumb">
              <li>
                <Link to={'/search'}>به روزرسان</Link>
              </li>
              <li>اطلاعات پایه</li>
              <li>وضعیت سفارشات</li>
              <li>برنامه تامین کنندگان</li>
              <li>ویرایش</li>
            </ul>
            <form className="verticalForm" onSubmit={this.submit.bind(this)}>
              <div className="headerVertical">
                <p>ویرایش برنامه تامین کننده</p>
              </div>

              <div className="formComponent selectComponent">
                <AutoComplete
                  label="تامین کننده"
                  api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                  textField="title"
                  valueField="providerId"
                  id="provider"
                  extraFilter={{id: this.state.providerId}}
                  value={this.state.providerId}
                  setValue={(providerId) => this.setState({providerId})}
                  required
                />
                {/* <label>تامین کننده :‌ <span className='requireFiled'>*</span></label>
                            <Select
                                value={selectedOption}
                                onChange={this.handleChange}
                                options={this.state.providers}
                                isMulti={false}
                                isClearable={true}
                                placeholder={''}
                                id="input_supplierName"
                                name="input_supplierName"
                                tabIndex='1'
                            /> */}
              </div>
              <div className="formComponent selectComponent">
                <label>کاربر مسئول :‌ </label>
                <Select
                  value={this.state.selectedOperator}
                  onChange={(selectedOperator) => this.setState({selectedOperator})}
                  options={this.state.operators}
                  isMulti={false}
                  isClearable={true}
                  placeholder={''}
                  tabIndex="1"
                />
              </div>

              <div className="formComponent">
                <label>
                  دارای برنامه تامین <span className="requireFiled">*</span>‌
                </label>
                <input
                  type="number"
                  id="productsWithPlan"
                  min={0}
                  onKeyPress={this.changeNumeric}
                  defaultValue={this.state.productsWithPlan}
                  className="form-control"
                />
              </div>

              <div className="formComponent">
                <label>
                  بدون برنامه تامین <span className="requireFiled">*</span>‌
                </label>
                <input
                  type="number"
                  id="productsWithoutPlan"
                  min={0}
                  onKeyPress={this.changeNumeric}
                  defaultValue={this.state.productsWithoutPlan}
                  className="form-control"
                />
              </div>
              <div className="formComponent">
                <button className="btn btn-info btn-block jasperBtn" onClick={this.edit.bind(this)}>
                  ویرایش برنامه تامین کننده
                </button>
                <p className="errorText" id="errorText" />
              </div>
            </form>
          </div>
        )}
      </div>
    )
  }
}
export default withRouter(EditProviderPlan)
